exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sync-legacy-page .table-sm[data-v-52b96860] {\n  font-size: 0.75rem;\n  line-height: 1.1rem;\n  font-family: SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;\n}", ""]);

// exports
